import notification from '@/ApiConstance/toast'
import { api } from '../index'

export default {
  async allAttendences(payload) {
    return await api.post('/getallattendences', payload)
  },

  async updateAttendenceSummary(payload) {
    return await api.post('/updateattendencesumary', payload).then(() => {
      notification.toast('SuccessFully Submited', 'success')
      window.location.href = '/attendences'
    })
  },
}
